/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".company-advanced-types[_ngcontent-%COMP%]   .Card-inner--top[_ngcontent-%COMP%], .company-advanced-types[_ngcontent-%COMP%]   .Card-inner--top[_ngcontent-%COMP%]   .Island[_ngcontent-%COMP%]{padding-top:0!important}.company-advanced-types[_ngcontent-%COMP%]   .Card--large[_ngcontent-%COMP%]   .Card-inner[_ngcontent-%COMP%]{padding:.3rem .5rem}.ConfigNav[_ngcontent-%COMP%]{margin-bottom:.5rem}.FormElement-cursorHand[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
